<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange"></SearchField>

    <Table ref="table" :tableHeight="tableHeight" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'violation',
      getListUrl: 'getViolationStatistics',
      formInline: {},
      formCtrl: [
        {
          label: "车牌号：",
          keyName: "license",
          placeholder: "请填写车牌号",
          type: "text",
        },
      ],
      cols: [
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "driver", label: "司机" },
        { prop: "violation_count", label: "违章次数" },
        { prop: "unresolved_count", label: "未处理" },
        { prop: "resolved_count", label: "已处理" },
        { prop: "total_kpoints", label: "扣分总计" },
        { prop: "unresolved_fine", label: "未处理罚款" },
        { prop: "resolved_fine", label: "已处理罚款" },
        { prop: "total_fine", label: "罚款总额" },
      ],
      btns: [
        {
          title: '违章详情',
          img: require('@/assets/img/icon_order.png'),
          unimg: require('@/assets/img/icon_order_hover.png'),
          cb: ({ license }) => {
            this.$router.push(
              `/vehicle/breakRules/detailList?license=${license}`
            );
          },
        },
      ],
    };
  },
  methods: {},
  mounted() {},
};
</script>
